module.exports = new __parcel__URL__("stardust_pink_icon_large.780d75e7.png").toString();